export enum FormMode {
	VIEW,
	CREATE,
	UPDATE,
}
